import { useState } from "react";
import {
  ResponseGetShippingSourceInformationResponse,
  RequestGetShippingSourceInformationRequest,
  ShippingSourceInformationGetShippingSourceInformationPostRequest,
  ShippingSourceInformationApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetShippingSourceInformation = () => {
  const [shippingSourceInformation, setShippingSourceInformation] =
    useState<ResponseGetShippingSourceInformationResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchShippingSourceInformation = async (
    requestParams: RequestGetShippingSourceInformationRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: ShippingSourceInformationGetShippingSourceInformationPostRequest =
        {
          req: requestParams,
        };

      const api = new ShippingSourceInformationApi(config);
      const response =
        await api.shippingSourceInformationGetShippingSourceInformationPost(
          request
        );
      setShippingSourceInformation(response);
      return response;
    } catch (err) {
      setError("配送元情報の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    shippingSourceInformation,
    fetchShippingSourceInformation,
    error,
    isLoading,
  };
};
